module.exports = __webpack_public_path__ + "img/nederland.4208ed35.png";